import React, { useEffect, useState, useRef } from "react";
import HttpService from "../../services/httpService";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { connect } from "react-redux";
import { Dialog, DialogContent, DialogTitle, DialogActions, Card, CardContent, FormControl, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from "@material-ui/core/Grid";
import Tooltip from '@material-ui/core/Tooltip';
import Skeleton from '@mui/material/Skeleton';
import CloseIcon from '@material-ui/icons/Close';
import { DownloadOutlined } from '@ant-design/icons';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    withStyles,
    TableContainer
} from "@material-ui/core";
import { Button } from "antd";
import { Modal } from "antd";
import { CSVLink } from "react-csv";
import moment from "moment";
import { ROLENAME, salesDepartment } from '../../utils/index';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    bordercolors: {
        border: '1px solid #eee5e5',
        background: "white",

    },
    table: {
        minWidth: 700,
    },
    root: {
        width: '100%',
    },
    title: {
        fontSize: 14,
    },
    customTableContainer: {
        overflowX: "initial"
    },
    pos: {
        marginBottom: 12,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginpivotRight: theme.spacing(1),
        width: 200,
    },
    table: {
        width: "fit-content",
    },
    csv: {
        display: "flex",
        alignItems: "center",
        marginBottom: 20,
    },
    report: {
        marginBottom: 20,
        alignItems: "center",
        justifyContent: "center",
    },
    clearButton: {
        backgroundColor: '#FFF2EB !important',   // Light Beige
        color: '#1C375D !important',             // Decorpot Orange text
        '&:hover': {
            backgroundColor: '#E7BAD0 !important', // Light Pink on hover
        },
    },
    searchButton: {
        backgroundColor: '#FDB913 !important',  // Bright Yellow for emphasis
        color: '#1C375D !important',            // Dark Blue text for contrast
        '&:hover': {
            backgroundColor: '#E6A411 !importan', // Darker yellow on hover
        },
    },
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#1C375D",
        color: '#FFF2EB',
        fontWeight: "500"
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);


const OpsReview = (props) => {
    const classes = useStyles();
    const { userDetails } = useSelector((state) => state.user);
    const [response, setResponse] = useState(false)
    const [stagesData, setStagesData] = useState([]);
    const [summaryData, setSummaryData] = useState([]);
    const [commonExpCenter, setExpCenter] = useState([])
    const [commonLocation, setLocation] = useState([])
    const [pivot, setPivot] = useState("Design Ops Review")
    const [storeDateFilter, setPivotDatefilters] = useState({ startDate: "", endDate: "" })
    const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([])
    const [selectedLocation, setSelectedLocation] = useState([])
    const [selectedValue, setSelectedValue] = useState("");
    const [showDetailedModal, setShowDetailedModal] = useState(false);
    const [selectedDesigners, setSelectedDesigners] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const csvButtonRef = useRef(null);
    const [popMonthData, setPopMonthData] = useState([]);
    const [isDesignersPopupVisible, setIsDesignersPopupVisible] = useState(false)
    const [selectedADM, setSelectedADM] = useState("")
    const [selectedRole, setSelectedRole] = useState('');
    const [usersData, setUsersData] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [status, setStaus] = useState('');
    const [selectLost, setSeletLost] = useState('')
    const [searchInput, setSearchInput] = useState("")
    const [selectedSearchType, setSelectedSearchType] = useState("");
    const searchTypes = ['Customer Name', 'Email ID', 'Lead No', 'Project No', 'Contact No', 'Unique Lead No']
    const [showAllStages, setShowAllStages] = useState(false);
    const [selectedMonths, setSelectedMonths] = useState("");
    const [totalWeekLabel, setTotalWeekLabel] = useState(false)
    const [currentMonthD2EData, setCurrentMonthD2EData] = useState(false)
    const [d2eDoneStageCount, setD2EDoneStageCount] = useState(0);
    const [qcStageCount, setQCStageCount] = useState(0);
    const [clientApprovalStageCount, setClientApprovalStageCount] = useState(0);
    const designStages = ['dnaPendingWithDesign', 'dkoInternal', 'dkoCustomer', 'lessThan1Month', 'between1And2Months', 'between2And3Months', 'between3And4Months', 'greaterThan4Months', 'designOnHold', 'total']
    const [tableCsvData, setTableCsvData] = useState([]);
    const tableCsvButtonRef = useRef(null);
    const [opsReviewTableCsvData, setOpsReviewTableCsvData] = useState([]);
    const opsReviewTableCsvButtonRef = useRef(null);
    const [triggerDownload, setTriggerDownload] = useState(false);
    // Function to toggle dropdown visibility
    const toggleDropdown = () => {
        setShowAllStages(!showAllStages);
    };

    // Filtered data to show
    const filteredStages = showAllStages
        ? stagesData
        : stagesData.filter(stage => stage.stage === 'Monthly Contract Target' || stage.stage === 'Monthly Contract Achieved' || stage.stage === "Slip Ons");


    useEffect(() => {
        expCenters();
        locations();
        if (userDetails.roles.find(role => role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser)) {
            // opsReview()
            admSummary()
            setSelectedRole(ROLENAME.DesignUser)
        } else {
            // opsReview()
            admSummary()
            setSelectedRole("ALL")
        }
    }, []);
    const months = [
        { label: 'January', value: 1 },
        { label: 'February', value: 2 },
        { label: 'March', value: 3 },
        { label: 'April', value: 4 },
        { label: 'May', value: 5 },
        { label: 'June', value: 6 },
        { label: 'July', value: 7 },
        { label: 'August', value: 8 },
        { label: 'September', value: 9 },
        { label: 'October', value: 10 },
        { label: 'November', value: 11 },
        { label: 'December', value: 12 }
    ];
    // const generateMonthsWithYears = () => {
    //     const currentYear = new Date().getFullYear();
    //     const nextYear = currentYear + 1;
    //     const months = [
    //         'January', 'February', 'March', 'April', 'May', 'June',
    //         'July', 'August', 'September', 'October', 'November', 'December'
    //     ];

    //     let options = [];
    //     for (let year of [currentYear, nextYear]) {
    //         months.forEach((month, index) => {
    //             options.push({ label: `${month} ${year}`, value: { month: index + 1, year } });
    //         });
    //     }

    //     return options;
    // };

    // const monthsWithYears = generateMonthsWithYears();
    const headers = [
        { key: "serialNo", label: "Sl. No." },
        { key: "projectCode", label: "Project No." },
        { key: "leadNumber", label: "Lead No." },
        { key: "clientName", label: "Client Name" },
        { key: "value", label: "Value" },
        { key: "currentStage", label: "Current Stage" },
        { key: "location", label: "City" },
        { key: "expCtrName", label: "Exp. Ctr Name" },
        { key: "salesWonDate", label: "Sales Won Date" },
        { key: "designerAssignedDate", label: "Designer Assigned Date" },
        // { key: "projectedDesignSignOffDate", label: "Projected Design Sign-Off Date" },
        // { key: "revisedProjectedDesignSignOffDate", label: "Revised Projected Design Sign-Off Date" },
        { key: "designAssistantManager", label: "ADM" },
        { key: "designUser", label: "Designer" },
    ];

    const csvDownloadHandler = async (data) => {
        setLoading(true);
        try {
            let csvArray = [];
            for (let i = 0; i < popMonthData.length; i++) {
                let obj = {
                    serialNo: i + 1,
                    projectCode: popMonthData[i]?.erpProjectNo || "N/A",
                    leadNumber: popMonthData[i]?.lead_no || "N/A",
                    clientName: popMonthData[i]?.customerId?.name,
                    value: popMonthData[i]?.staticSalesWonBudget || "N/A",
                    location: popMonthData[i]?.city?.name,
                    expCtrName: popMonthData[i]?.experienceCenterId?.name,
                    currentStage: popMonthData[i]?.currentStage ? popMonthData[i]?.currentStage : 'NA',
                    salesWonDate: popMonthData[i]?.leadWonDate
                        ? moment(popMonthData[i]?.leadWonDate).format("DD-MM-YYYY")
                        : "-",
                    designerAssignedDate: popMonthData[i]?.designerAssignedDate
                        ? moment(popMonthData[i]?.designerAssignedDate).format("DD-MM-YYYY")
                        : "-",
                    designDGM: popMonthData[i]?.designDGM ? popMonthData[i]?.designDGM?.name : 'NA',
                    designAssistantManager: popMonthData[i]?.designManager ? popMonthData[i]?.designManager?.name : 'NA',
                    designUser: popMonthData[i]?.designUser?.name ? popMonthData[i]?.designUser?.name : 'NA',
                };
                csvArray.push(obj);
                // obj = {
                //     serialNo: "",
                //     projectCode: "",
                //     clientName: "",
                //     totalValue: "",
                //     expCtrName: "",
                //     salesWonDate: "",
                //     projectedDesignSignOffDate: "",
                //     revisedProjectedDesignSignOffDate: "",
                // };
                // csvArray.push(obj);
            }
            setCsvData(csvArray);
            downloadExcel();
        } catch (error) {
            console.log("error ->", error);
            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };

    const downloadExcel = () => {
        setLoading(true);
        try {
            setTimeout(() => {
                csvButtonRef.current.link.click();
            });
        } catch (err) {
            console.error(err.message);
        }
        setLoading(false);
    };
    const expCenterData = {};
    stagesData.forEach((el) => {
        if (!expCenterData[el.experienceCenterName]) {
            expCenterData[el.experienceCenterName] = [];
        }
        expCenterData[el.experienceCenterName].push(el);
    });

    const uniqueexperienceCenterCode = Array.from(new Set(stagesData.map((el) => el.expCenterCode)));
    let uniqueexperienceCenterNames = Array.from(new Set(stagesData.map((el) => el.experienceCenterName)));


    const expCenters = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getExpericenCenters();
            const matchedUsers = response.data.filter(user => {
                return userDetails.experienceCenterId.includes(user._id);
            });
            setExpCenter(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const locations = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getLocation();
            const matchedUsers = response.data.filter(user => {
                return userDetails.selectedLocation.includes(user._id);
            });
            setLocation(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

        // Trigger CSV download when data is ready
        useEffect(() => {
            if (triggerDownload && opsReviewTableCsvData.length > 0) {
                const timer = setTimeout(() => {
                    if (opsReviewTableCsvButtonRef.current?.link) {
                        try {
                            opsReviewTableCsvButtonRef.current.link.click();
                        } catch (error) {
                            console.error("Error triggering CSV download:", error);
                            props?.setSnackInfo("Error downloading CSV", "error");
                        }
                        setTriggerDownload(false);
                    } else {
                        // Retry if link is not ready
                        setTimeout(() => {
                            if (opsReviewTableCsvButtonRef.current?.link) {
                                opsReviewTableCsvButtonRef.current.link.click();
                                setTriggerDownload(false);
                            }
                        }, 200);
                    }
                }, 300);
                
                return () => clearTimeout(timer);
            }
        }, [triggerDownload, opsReviewTableCsvData]);
    
        // Function to generate CSV data for ops review table
        const generateOpsReviewTableCsvData = () => {
            try {
                if (!summaryData || summaryData.length === 0) {
                    return [];
                }
    
                const csvRows = [];
    
                // Build header row - match table structure exactly
                const headerRow = {
                    "ADM's Name": "",
                    "Designers": "",
                    "DNA Pending With Design": "",
                    "DKO Internal": "",
                    "DKO Customer": "",
                    "LessThan1Month": "",
                    "1To2Months": "",
                    "2To3Months": "",
                    "3To4Months": "",
                    "GreaterThan4Months": "",
                    "Design on Hold": "",
                    "Total": ""
                };
                csvRows.push(headerRow);
    
                // Add data rows for each ADM
                summaryData.forEach((row) => {
                    const csvRow = {
                        "ADM's Name": row?.admName || "",
                        "Designers": row?.designersCount || 0,
                        "DNA Pending With Design": row?.leadData?.dnaPendingWithDesign?.count || 0,
                        "DKO Internal": row?.leadData?.dkoInternal?.count || 0,
                        "DKO Customer": row?.leadData?.dkoCustomer?.count || 0,
                        "LessThan1Month": row?.leadData?.lessThan1Month?.count || 0,
                        "1To2Months": row?.leadData?.between1And2Months?.count || 0,
                        "2To3Months": row?.leadData?.between2And3Months?.count || 0,
                        "3To4Months": row?.leadData?.between3And4Months?.count || 0,
                        "GreaterThan4Months": row?.leadData?.greaterThan4Months?.count || 0,
                        "Design on Hold": row?.leadData?.designOnHold?.count || 0,
                        "Total": row?.leadData?.total?.count || 0
                    };
                    csvRows.push(csvRow);
                });
    
                return csvRows;
            } catch (error) {
                console.error("Error generating ops review table CSV:", error);
                return [];
            }
        };

    const currentMonthD2E = (data) => {
        // Initialize counts
        let qcCount = 0;
        let d2eCount = 0;
        let clientCount = 0

        // Iterate through the array
        data.forEach((item) => {
            if (item.currentStage === "Drawing QC") {
                qcCount++;
            }
            if (item.designToExecutionLogsStatus === "Approved") {
                d2eCount++;
            }
            if (item.designToExecutionLogsStatus === "Sent For Approval" && (!item.contractCustomerApproved || item.contractBusinessHeadApproved)) {
                clientCount++
            }
        });
        setD2EDoneStageCount(d2eCount);
        setQCStageCount(qcCount);
        setClientApprovalStageCount(clientCount);
        setCurrentMonthD2EData((prevState) => !prevState);
    };


    const opsReview = async (addLocation, addExpCenter, selectedMonths, usersData, selectedSearchType, searchInput) => {
        let locationData = addLocation?.map((el) => el._id)
        let expCenterData = addExpCenter?.map((el) => el._id)
        // let monthsData = selectedMonths?.map((el) => el.label)
        let users = ''
        if ((usersData?.users && usersData?.users.length !== 0) || (selectedUsers && selectedUsers.length !== 0)) {
            users = usersData?.users?.map((el) => el._id) || selectedUsers?.map((el) => el._id)
        }
        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            selectedMonths: selectedMonths ? selectedMonths.label : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            selectedLocation: locationData ? locationData : "",
            users: users ? users : "",
            userExpCenter: userDetails.experienceCenterId,
            userLocation: userDetails.selectedLocation,
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : ""
        }
        if (userDetails.roles.find(role => role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser)) {
            obj.selectedRole = usersData?.role ? usersData?.role : ROLENAME.DesignUser
        } else {
            obj.selectedRole = usersData?.role ? usersData?.role : (selectedRole ? selectedRole : "ALL")
        }
        props.setLoading(true);
        try {
            let response = await HttpService.opsReview(obj);
            if (response.status === 200) {
                setResponse(true)
                setStagesData(response.data);
            }
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const admSummary = async (addLocation, addExpCenter, selectedMonths, usersData, selectedSearchType, searchInput) => {
        setSummaryData([])
        let locationData = addLocation?.map((el) => el._id)
        let expCenterData = addExpCenter?.map((el) => el._id)
        // let monthsData = selectedMonths?.map((el) => el.label)
        let users = ''
        if ((usersData?.users && usersData?.users.length !== 0) || (selectedUsers && selectedUsers.length !== 0)) {
            users = usersData?.users?.map((el) => el._id) || selectedUsers?.map((el) => el._id)
        }
        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            selectedMonths: selectedMonths ? selectedMonths.label : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            selectedLocation: locationData ? locationData : "",
            users: users ? users : "",
            userExpCenter: userDetails.experienceCenterId,
            userLocation: userDetails.selectedLocation,
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : ""
        }
        if (userDetails.roles.find(role => role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser)) {
            obj.selectedRole = usersData?.role ? usersData?.role : ROLENAME.DesignUser
        } else {
            obj.selectedRole = usersData?.role ? usersData?.role : (selectedRole ? selectedRole : "ALL")
        }
        props.setLoading(true);
        try {
            let response = await HttpService.admSummary(obj);
            setSummaryData(response.data);
        } catch (error) {
            console.log("ADM Summary Error ->", error)
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const formatNumberToTwoDecimalPlaces = (value) => {
        return parseFloat(value).toFixed(2);
    }

    const storePivotDate = (e) => {
        const { name, value } = e.target
        setPivotDatefilters({ ...storeDateFilter, [name]: value })
    }
    const handlePivotDateFilter = () => {
        // opsReview(selectedLocation, selectedExperienceCenter, selectedMonths, selectedUsers, selectedSearchType, searchInput)
    }

    const handleSearchType = (value) => {
        setSelectedSearchType(value)
        setSearchInput('')
    }

    const handleSearch = async (value) => {
        // opsReview(selectedLocation, selectedExperienceCenter, selectedMonths, selectedUsers, selectedSearchType, searchInput)
        admSummary(selectedLocation, selectedExperienceCenter, selectedMonths, selectedUsers, selectedSearchType, searchInput)
    }
    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && selectedSearchType && searchInput) {
            handleSearch(searchInput.toUpperCase());
        }
    };

    const handleMultipleExpData = (e, newvalue) => {
        setSelectedExperienceCenter(newvalue)
        handleExpData(newvalue)
    }
    const handleExpData = async (newvalue) => {
        props.setLoading(true);
        // await opsReview(selectedLocation, newvalue, selectedMonths, selectedUsers, selectedSearchType, searchInput)
        await admSummary(selectedLocation, newvalue, selectedMonths, selectedUsers, selectedSearchType, searchInput)
        props.setLoading(false);
    }


    const handleMultipleLocationData = (e, newValue) => {
        setSelectedLocation(newValue)
        handleLocationData(newValue)
    }
    const handleLocationData = async (newValue) => {
        props.setLoading(true);
        // await opsReview(newValue, selectedExperienceCenter, selectedMonths, selectedUsers, selectedSearchType, searchInput)
        await admSummary(newValue, selectedExperienceCenter, selectedMonths, selectedUsers, selectedSearchType, searchInput)
        props.setLoading(false);
    }

    // const handleMonthChange = async (event, value) => {
    //     setSelectedMonths(value)
    //     await opsReview(selectedLocation, selectedExperienceCenter, value, selectedUsers, selectedSearchType, searchInput)
    // };

    // const handleSelectRoles = async (event, role) => {
    //     setSelectedUsers([])
    //     let obj = {}
    //     if (role) {
    //         obj.role = role
    //     } else {
    //         setSelectedRole(event.target.value)
    //         obj.role = event.target.value
    //     }
    //     obj.pivotValue = pivot
    //     try {
    //         let response = await HttpService.getSelectedUsersBasedOnRoles(obj);
    //         if (!role) {
    //             await opsReview(selectedLocation, selectedExperienceCenter, selectedMonths, obj, selectedSearchType, searchInput)
    //         }
    //         setUsersData(response.data);
    //     } catch (error) {
    //         props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
    //     }
    // }

    const handleCellClick = (weekData, pivot) => {
        if (weekData.weekLabel === "Total") {
            setTotalWeekLabel(true)
        }
        setPopMonthData(weekData.data || []); // Set the data for the modal
        // setPivot(pivot); // Set whether it was "Value" or "Count"
        setShowDetailedModal(true); // Show the modal
    };

    const dataShow = (data) => {
        setPopMonthData(data)
        setShowDetailedModal(true)
    }

    const handleShowDesignersPopup = (designers, admName) => {
        setSelectedDesigners(designers);
        setSelectedADM(admName);
        setIsDesignersPopupVisible(true);
    };

    const handleMultipleUsers = (e, newvalue) => {
        setSelectedUsers(newvalue)
        handleUsersData(newvalue)
    }

    const handleUsersData = async (newvalue) => {
        props.setLoading(true);
        let obj = {
            users: newvalue,
            role: selectedRole
        }
        // await opsReview(selectedLocation, selectedExperienceCenter, selectedMonths, obj, selectedSearchType, searchInput)
        props.setLoading(false);
    }

    const clearDateFilter = () => {
        setSearchInput("")
        setSelectedSearchType("")
        // opsReview(selectedLocation, selectedExperienceCenter, selectedMonths, selectedUsers, "", "")
        admSummary(selectedLocation, selectedExperienceCenter, selectedMonths, selectedUsers, "", "")
    }

    const tableHeaders = [
        { key: "serialNo", label: "Sl. No." },
        { key: "projectCode", label: "Project No." },
        { key: "leadNumber", label: "Lead No." },
        { key: "clientName", label: "Client Name" },
        { key: "valueInr", label: "Value (INR)" },
        { key: "city", label: "City" },
        { key: "expCtrName", label: "Exp. Ctr. Name" },
        { key: "salesWonDate", label: "Sales Won Date" },
        { key: "designerAssignedDate", label: "Designer Assigned Date" },
        { key: "designer", label: "Designer" },
        { key: "odm", label: "ODM" },
        { key: "currentStage", label: "Current Stage" },
        { key: "designStatus", label: "Design Status" },
    ];

    const tableCsvDownloadHandler = () => {
        setLoading(true);
        try {
            let csvArray = [];
            for (let i = 0; i < popMonthData.length; i++) {
                const data = popMonthData[i];
                let obj = {
                    serialNo: i + 1,
                    projectCode: data?.erpProjectNo || "N/A",
                    leadNumber: data?.lead_no || "N/A",
                    clientName: data?.customerId?.name || "N/A",
                    valueInr: data?.staticSalesWonBudget || "N/A",
                    city: data?.city?.name || "N/A",
                    expCtrName: data?.experienceCenterId?.name || "N/A",
                    salesWonDate: data?.leadWonDate ? moment(data?.leadWonDate).format("DD-MM-YYYY") : "-",
                    designerAssignedDate: data?.designerAssignedDate ? moment(data?.designerAssignedDate).format("DD-MM-YYYY") : "-",
                    designer: data?.designUser?.name || "NA",
                    odm: data?.designManager?.name || "NA",
                    currentStage: data?.currentStage || "NA",
                    designStatus: data?.designStatus || "NA",
                };
                csvArray.push(obj);
            }
            setTableCsvData(csvArray);
            setTimeout(() => {
                tableCsvButtonRef.current.link.click();
            });
        } catch (error) {
            console.log("error ->", error);
            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };

    return (
        <div className="App">
            <br />
            <div>
                <Paper className={classes.paper}>
                    <Grid container spacing={2} justifyContent="center" alignItems="center">
                        <Grid item xs={12} sm={3}>
                            <FormControl style={{ width: '100%' }}>
                                <Autocomplete
                                    multiple
                                    value={selectedLocation}
                                    onChange={handleMultipleLocationData}
                                    options={commonLocation}
                                    getOptionLabel={(option) => option.name}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select Location"
                                            variant="outlined"
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <FormControl style={{ width: '100%' }}>
                                <Autocomplete
                                    multiple
                                    value={selectedExperienceCenter}
                                    onChange={handleMultipleExpData}
                                    options={commonExpCenter}
                                    getOptionLabel={(option) => option.name}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select Exp-Center"
                                            variant="outlined"
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        {/* <Grid item xs={12} sm={3}>
                            <FormControl style={{ width: '100%' }}>
                                <Autocomplete
                                    id="fromMonths"
                                    options={months}
                                    getOptionLabel={(option) => option?.label || ""}
                                    value={selectedMonths}
                                    onChange={handleMonthChange}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            label="Select Month"
                                            placeholder="Select Month"
                                            fullWidth
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid> */}
                    </Grid>
                    {/* <Grid container spacing={2} justifyContent="center" alignItems="center">
                        {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.DGM_Design].includes(role.name))) && (
                            <>
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '90%', marginTop: "0.4rem" }}>
                                        <TextField
                                            select
                                            labelId="project-doc"
                                            label="Select Role"
                                            variant="outlined"
                                            value={selectedRole}
                                            onChange={(e) => handleSelectRoles(e)}
                                        >
                                            <MenuItem value={"ALL"}>ALL</MenuItem>
                                            <MenuItem value={ROLENAME.DGM_Design}>DGM</MenuItem>
                                            <MenuItem value={ROLENAME.OperationDesignManager}>Operation Design Manager</MenuItem>
                                            <MenuItem value={ROLENAME.AssistantDesignManager}>Assistant Design Manager</MenuItem>
                                            <MenuItem value={ROLENAME.DesignUser}>Designer</MenuItem>
                                        </TextField>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '100%', marginTop: '0.30rem' }}>
                                        <Autocomplete
                                            multiple
                                            value={selectedUsers}
                                            onChange={(e, v) => handleMultipleUsers(e, v)}
                                            options={usersData}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" />}
                                        />
                                    </FormControl>
                                </Grid>
                            </>
                        )}

                        {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.OperationDesignManager].includes(role.name))) && (
                            <>
                                <Grid item xs={12} sm={2}>
                                    <FormControl style={{ width: '80%', marginTop: "0.4rem" }}>
                                        <TextField
                                            select
                                            labelId="project-doc"
                                            label="Select Role"
                                            variant="outlined"
                                            value={selectedRole}
                                            onChange={(e) => handleSelectRoles(e)}
                                        >
                                            <MenuItem value={ROLENAME.OperationDesignManager}>Operation Design Manager</MenuItem>
                                            <MenuItem value={ROLENAME.AssistantDesignManager}>Assistant Design Manager</MenuItem>
                                            <MenuItem value={ROLENAME.DesignUser}>Designer</MenuItem>
                                        </TextField>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '100%', marginTop: '0.30rem' }}>
                                        <Autocomplete
                                            multiple
                                            value={selectedUsers}
                                            onChange={(e, v) => handleMultipleUsers(e, v)}
                                            options={usersData}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" />}
                                        />
                                    </FormControl>
                                </Grid>
                            </>
                        )}

                        {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.AssistantDesignManager].includes(role.name))) && (
                            <>
                                <Grid item xs={12} sm={4}>
                                    <FormControl style={{ width: '100%', marginTop: "0.4rem" }}>
                                        <TextField
                                            select
                                            labelId="project-doc"
                                            label="Select Role"
                                            variant="outlined"
                                            value={selectedRole}
                                            onChange={(e) => handleSelectRoles(e)}
                                        >
                                            <MenuItem value={ROLENAME.AssistantDesignManager}>Assistant Design Manager</MenuItem>
                                            <MenuItem value={ROLENAME.DesignUser}>Designer</MenuItem>
                                        </TextField>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <FormControl style={{ width: '100%', marginTop: '0.30rem' }}>
                                        <Autocomplete
                                            multiple
                                            size="medium"
                                            value={selectedUsers}
                                            onChange={(e, v) => handleMultipleUsers(e, v)}
                                            ListboxProps={{ style: { maxHeight: "15rem" }, position: "bottom-start" }}
                                            options={usersData}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" />}
                                        />
                                    </FormControl>
                                </Grid>
                            </>
                        )}
                    </Grid> */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '30px' }}>
                        {/* Search Type Dropdown */}
                        <TextField
                            select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedSearchType}
                            label="Search Type"
                            name="searchType"
                            onChange={(e) => handleSearchType(e.target.value)}
                            variant="outlined"
                            style={{ width: '30%', marginRight: '2%' }}
                            size="small"
                        >
                            {searchTypes && searchTypes?.map((el, index) => (
                                <MenuItem key={index} value={el}>{el}</MenuItem>
                            ))}
                        </TextField>

                        {/* Search Input */}
                        <TextField
                            label="Enter the input"
                            name="searched"
                            size="small"
                            value={searchInput}
                            onChange={(e) => { setSearchInput(e.target.value) }}
                            onKeyDown={handleKeyDown}  // Listening for the "Enter" key press
                            variant="outlined"
                            style={{ width: '80%' }}
                        />

                        {/* Search Button */}
                        <Button
                            disabled={!selectedSearchType || !searchInput}
                            variant="contained"
                            color="primary"
                            size="medium"
                            style={{ alignSelf: "center", marginLeft: 20 }}
                            className={classes.searchButton}
                            onClick={() => handleSearch(searchInput.toUpperCase())}
                        >
                            Search
                        </Button>

                        {/* Clear Filter Button */}
                        <Button
                            variant="contained"
                            color="secondary"
                            size="medium"
                            style={{ marginLeft: 10, marginTop: "4px" }}
                            className={classes.clearButton}
                            onClick={clearDateFilter}
                        >
                            Clear Filter
                        </Button>
                    </div>
                </Paper>
            </div>
            <br />
            {/* <div>
                <>
                    <div style={{ maxHeight: '600px', overflow: 'auto' }}>
                        <TableContainer
                            component={Paper}
                            classes={{ root: classes.customTableContainer }}
                            style={{ marginTop: '30px' }}
                        >
                            <Table style={{ minWidth: '600px' }}>
                                <TableHead style={{ position: 'sticky', top: 0, zIndex: 9, background: 'white' }}>
                                    <StyledTableRow>
                                        <StyledTableCell className={classes.stageHeader} rowSpan={2}>Stage</StyledTableCell>
                                        {(stagesData.length > 0 || response) ? (
                                            stagesData[0]?.weeklyData?.map((week, index) => (
                                                <StyledTableCell key={index} colSpan={2} className={classes.weekHeader} style={{ textAlign: "center" }}>
                                                    {week.weekLabel}
                                                </StyledTableCell>
                                            ))
                                        ) : (
                                            Array.from({ length: 4 }).map((_, index) => (
                                                <StyledTableCell key={index} colSpan={2} className={classes.weekHeader} style={{ textAlign: "center" }}>
                                                    <Skeleton variant="text" width={80} />
                                                </StyledTableCell>
                                            ))
                                        )}
                                    </StyledTableRow>

                                    <StyledTableRow>
                                        {(stagesData.length > 0 || response) ? (
                                            stagesData[0]?.weeklyData?.map((week, index) => (
                                                <>
                                                    <StyledTableCell key={`value-${index}`} className={classes.weekHeader} style={{ textAlign: "center" }}>
                                                        Value
                                                    </StyledTableCell>
                                                    <StyledTableCell key={`count-${index}`} className={classes.weekHeader} style={{ textAlign: "center" }}>
                                                        Count
                                                    </StyledTableCell>
                                                </>
                                            ))
                                        ) : (
                                            Array.from({ length: 4 }).map((_, index) => (
                                                <>
                                                    <StyledTableCell key={`value-${index}`} className={classes.weekHeader} style={{ textAlign: "center" }}>
                                                        <Skeleton variant="text" width={60} />
                                                    </StyledTableCell>
                                                    <StyledTableCell key={`count-${index}`} className={classes.weekHeader} style={{ textAlign: "center" }}>
                                                        <Skeleton variant="text" width={60} />
                                                    </StyledTableCell>
                                                </>
                                            ))
                                        )}
                                    </StyledTableRow>
                                </TableHead>

                                <TableBody>
                                    {(stagesData.length > 0 || response) ? (
                                        filteredStages?.map((stage, stageIndex) => (
                                            <StyledTableRow key={stageIndex}>
                                                <StyledTableCell className={classes.bordercolors} style={{ background: '#d3d3d3', fontWeight: 'bold' }}>{stage.stage}</StyledTableCell>
                                                {stagesData[0]?.weeklyData?.map((week, weekIndex) => {
                                                    const weekData = stage.weeklyData.find((weekly) => weekly.weekLabel === week.weekLabel);
                                                    return (
                                                        <>
                                                            <StyledTableCell
                                                                key={`value-${weekIndex}`}
                                                                className={classes.bordercolors}
                                                                style={{ textAlign: "center", cursor: "pointer", color: "blue", textDecoration: 'underline' }}
                                                                onClick={() => handleCellClick(weekData, 'Value')}
                                                            >
                                                                {weekData?.totalValue || 0}
                                                            </StyledTableCell>
                                                            <StyledTableCell
                                                                key={`count-${weekIndex}`}
                                                                className={classes.bordercolors}
                                                                style={{ textAlign: "center", cursor: "pointer", color: "blue", textDecoration: 'underline' }}
                                                                onClick={() => handleCellClick(weekData, 'Count')}
                                                            >
                                                                {weekData?.count || 0}
                                                            </StyledTableCell>
                                                        </>
                                                    );
                                                })}
                                            </StyledTableRow>
                                        ))
                                    ) : (
                                        Array.from({ length: 4 }).map((_, rowIndex) => (
                                            <StyledTableRow key={rowIndex}>
                                                <StyledTableCell className={classes.bordercolors}><Skeleton variant="text" width={80} /></StyledTableCell>
                                                {Array.from({ length: 4 }).map((_, colIndex) => (
                                                    <>
                                                        <StyledTableCell key={`value-${colIndex}`} className={classes.bordercolors}>
                                                            <Skeleton variant="rectangular" width={50} height={20} />
                                                        </StyledTableCell>
                                                        <StyledTableCell key={`count-${colIndex}`} className={classes.bordercolors}>
                                                            <Skeleton variant="rectangular" width={50} height={20} />
                                                        </StyledTableCell>
                                                    </>
                                                ))}
                                            </StyledTableRow>
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </>
            </div> */}

            {/* Second Table for Summary Data */}
            <div style={{ marginTop: '30px', maxHeight: '800px', overflow: 'auto' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '20px', marginBottom: '20px' }}>
                    <CSVLink
                        data={opsReviewTableCsvData}
                        filename={`Ops_Review_Dashboard_${moment().format('YYYY-MM-DD')}.csv`}
                        ref={opsReviewTableCsvButtonRef}
                        style={{ textDecoration: 'none', display: 'none' }}
                    />
                    <Button
                        type="primary"
                        icon={<DownloadOutlined />}
                        style={{
                            backgroundColor: "#355025",
                            color: "#FFF2EB",
                            padding: "0.4rem 2rem",
                            border: "none"
                        }}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            
                            const csvData = generateOpsReviewTableCsvData();

                            if (csvData.length > 0) {
                                setOpsReviewTableCsvData(csvData);
                                setTimeout(() => {
                                    setTriggerDownload(true);
                                }, 100);
                            } else {
                                props?.setSnackInfo("No data available to export", "warning");
                            }
                        }}
                    >
                        Download CSV
                    </Button>
                </div>
                <TableContainer component={Paper} classes={{ root: classes.customTableContainer }}>
                    <Table style={{ minWidth: '600px' }}>
                        {/* Table Head */}
                        <TableHead style={{ position: 'sticky', top: 0, zIndex: 9, background: 'white' }}>
                            <StyledTableRow>
                                <StyledTableCell>ADM's Name</StyledTableCell>
                                <StyledTableCell>Designers</StyledTableCell>
                                <StyledTableCell>DNA Pending With Design</StyledTableCell>
                                <StyledTableCell>DKO Internal</StyledTableCell>
                                <StyledTableCell>DKO Customer</StyledTableCell>
                                <StyledTableCell>LessThan1Month</StyledTableCell>
                                <StyledTableCell>1To2Months</StyledTableCell>
                                <StyledTableCell>2To3Months</StyledTableCell>
                                <StyledTableCell>3To4Months</StyledTableCell>
                                <StyledTableCell>GreaterThan4Months</StyledTableCell>
                                <StyledTableCell>Design on Hold</StyledTableCell>
                                <StyledTableCell>Total</StyledTableCell>
                            </StyledTableRow>
                        </TableHead>

                        {/* Table Body */}
                        <TableBody>
                            {summaryData.length > 0 ? (
                                summaryData.map((row, index) => {
                                    const isTotalRow = row?.admName === 'Total';

                                    return (
                                        <StyledTableRow component="th" key={index}>
                                            <StyledTableCell style={{ background: '#d3d3d3', fontWeight: 'bold' }}>
                                                {row?.admName}
                                            </StyledTableCell>

                                            <StyledTableCell
                                                onClick={() => handleShowDesignersPopup(row?.designersData, row?.admName)}
                                                style={{
                                                    textAlign: "center",
                                                    cursor: 'pointer',
                                                    color: 'blue',
                                                    textDecoration: 'underline',
                                                    background: isTotalRow ? '#d3d3d3' : 'white',
                                                }}
                                                component="th" 
                                            >
                                                {row?.designersCount || 0}
                                            </StyledTableCell>

                                            {designStages.map((key) => (
                                                <StyledTableCell
                                                    component="th" 
                                                    key={key}
                                                    onClick={() => dataShow(row?.leadData?.[key]?.leads)}
                                                    style={{
                                                        textAlign: "center",
                                                        cursor: 'pointer',
                                                        color: 'blue',
                                                        textDecoration: 'underline',
                                                        background: isTotalRow || key === "total" ? '#d3d3d3' : 'white',
                                                    }}
                                                >
                                                    {row?.leadData?.[key]?.count || 0}
                                                </StyledTableCell>
                                            ))}
                                        </StyledTableRow>
                                    );
                                })
                            ) : (
                                Array.from({ length: 5 }).map((_, rowIndex) => (
                                    <StyledTableRow key={rowIndex}>
                                        <StyledTableCell component="th"><Skeleton variant="text" width={120} /></StyledTableCell>
                                        <StyledTableCell component="th"><Skeleton variant="text" width={80} /></StyledTableCell>
                                        {Array.from({ length: 10 }).map((_, colIndex) => (
                                            <StyledTableCell component="th" key={colIndex}>
                                                <Skeleton variant="rectangular" width={50} height={20} />
                                            </StyledTableCell>
                                        ))}
                                    </StyledTableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>

            <Dialog open={isDesignersPopupVisible}>
                <DialogContent>
                    {/* Dynamic Title */}
                    <DialogTitle>
                        {selectedDesigners.length > 0
                            ? `Designers Under the ADM - ${selectedADM}`
                            : "Designers List"}
                    </DialogTitle>

                    <Card>
                        <CardContent>
                            <div>
                                <Table>
                                    {/* Table Header */}
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell component="th">Sl. No</StyledTableCell>
                                            <StyledTableCell component="th">Designer</StyledTableCell>
                                            <StyledTableCell component="th">ADM</StyledTableCell>
                                            <StyledTableCell component="th">Mobile</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>

                                    {/* Table Body */}
                                    <TableBody>
                                        {selectedDesigners.length > 0 ? (
                                            selectedDesigners.map((designer, index) => (
                                                <StyledTableRow key={designer._id}>
                                                    <StyledTableCell component="th" style={{ background: 'white' }}>{index + 1}</StyledTableCell>
                                                    <StyledTableCell component="th" style={{ background: 'white' }}>{designer.name}</StyledTableCell>
                                                    <StyledTableCell component="th" style={{ background: 'white' }}>{designer.assistantManagerId?.name}</StyledTableCell>
                                                    <StyledTableCell component="th" style={{ background: 'white' }}>{designer.mobile}</StyledTableCell>
                                                </StyledTableRow>
                                            ))
                                        ) : (
                                            <StyledTableRow>
                                                <StyledTableCell colSpan="5" className="text-center text-gray-500 py-4">
                                                    No Designers Found
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </div>
                        </CardContent>
                    </Card>

                    {/* Close Button at Bottom-Right */}
                    <DialogActions>
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: "#f50057", // Custom color
                                color: "white",
                                "&:hover": { backgroundColor: "#c51162" }, // Darker on hover
                            }}
                            onClick={() => setIsDesignersPopupVisible(false)}
                            startIcon={<CloseIcon />}
                        >
                            Close
                        </Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>


            <Modal
                title={pivot}
                centered
                visible={showDetailedModal}
                onCancel={() => {
                    setShowDetailedModal(false);
                    setTotalWeekLabel(false);
                    setCurrentMonthD2EData(false);
                }}
                width={1000}
                maskClosable={true}
                footer={null}
            >
                {
                    totalWeekLabel && (
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
                            <Button
                                onClick={() => currentMonthD2E(popMonthData)}
                                style={{
                                    backgroundColor: "#355025",
                                    color: "#FFF2EB",
                                    padding: '6px 16px',
                                    fontWeight: 'bold',
                                }}
                            >
                                Current Month D2E
                            </Button>
                        </div>

                    )
                }
                <div className={classes.csv}>
                    <CSVLink
                        headers={headers}
                        filename={`${pivot}.csv`}
                        data={csvData}
                        ref={csvButtonRef}
                    />
                    <Button
                        onClick={() => csvDownloadHandler(popMonthData)}
                        style={{ backgroundColor: "#355025", color: "#FFF2EB", marginRight: '10px' }}
                        variant="contained"
                        color="secondary"
                    >
                        Download CSV
                    </Button>
                </div>
                {currentMonthD2EData && (
                    <TableContainer
                        component={Paper}
                        style={{
                            marginTop: '20px',
                            marginBottom: '20px',
                            width: '50%', // Adjust width as needed
                        }}
                    >
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        style={{
                                            fontWeight: 'bold',
                                            borderBottom: '2px solid black',
                                            textAlign: 'left',
                                        }}
                                    >
                                        Stages
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            fontWeight: 'bold',
                                            borderBottom: '2px solid black',
                                            textAlign: 'left',
                                        }}
                                    >
                                        Count
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell style={{ borderBottom: '1px solid #ccc', padding: '8px' }}>
                                        D2E Done
                                    </TableCell>
                                    <TableCell style={{ borderBottom: '1px solid #ccc', padding: '8px' }}>
                                        {d2eDoneStageCount}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ borderBottom: '1px solid #ccc', padding: '8px' }}>
                                        Client Approval Stage
                                    </TableCell>
                                    <TableCell style={{ borderBottom: '1px solid #ccc', padding: '8px' }}>
                                        {clientApprovalStageCount}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ borderBottom: '1px solid #ccc', padding: '8px' }}>
                                        Drawing QC Stage
                                    </TableCell>
                                    <TableCell style={{ borderBottom: '1px solid #ccc', padding: '8px' }}>
                                        {qcStageCount}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}

                {popMonthData && (
                    <TableContainer component={Paper} className={classes.table}>
                        <Table
                            style={{ width: 450 }}
                            className={classes.table}
                            stickyHeader
                            aria-label="sticky table"
                        >
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell>Sl. No.</StyledTableCell>
                                    <StyledTableCell>Project No.</StyledTableCell>
                                    <StyledTableCell>Lead No.</StyledTableCell>
                                    <StyledTableCell>Client Name</StyledTableCell>
                                    <StyledTableCell>Value (INR)</StyledTableCell>
                                    <StyledTableCell>City</StyledTableCell>
                                    <StyledTableCell>Exp. Ctr. Name</StyledTableCell>
                                    <StyledTableCell>Sales Won Date</StyledTableCell>
                                    <StyledTableCell>Designer Assigned Date</StyledTableCell>
                                    <StyledTableCell>Designer</StyledTableCell>
                                    <StyledTableCell>ADM</StyledTableCell>
                                    {/* <StyledTableCell>Projected Design Sign-Off Date</StyledTableCell> */}
                                    {/* <StyledTableCell>Revised Projected Design Sign-Off Date</StyledTableCell> */}
                                    <StyledTableCell>Current Stage</StyledTableCell>
                                    <StyledTableCell>Design Status</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {popMonthData?.map((data, i) => {
                                    return (
                                        <StyledTableRow key={i}>
                                            <StyledTableCell>{i + 1}</StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >

                                                {
                                                    data?.erpProjectNo ?
                                                        <Link to={`/project-logs/${data?._id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}>  {data?.erpProjectNo}</Link> :
                                                        'NA'
                                                }

                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {
                                                    data?.lead_no ?
                                                        <Link to={`/project-logs/${data?._id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}>  {data?.lead_no}</Link> :
                                                        'NA'
                                                }

                                            </StyledTableCell>
                                            <StyledTableCell
                                                component="th"
                                                style={{ textAlign: "center" }}
                                            >
                                                {data?.customerId.name}
                                            </StyledTableCell>
                                            {
                                                <>
                                                    <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                        {data?.staticSalesWonBudget?.toLocaleString("en-IN", {
                                                            maximumFractionDigits: 2, // Maximum number of decimal places
                                                            style: "currency",
                                                            currency: "INR",
                                                        })}
                                                    </StyledTableCell>
                                                </>
                                            }
                                            <StyledTableCell component="th">
                                                {data?.city?.name}
                                            </StyledTableCell>
                                            <StyledTableCell component="th">
                                                {data?.experienceCenterId?.name}
                                            </StyledTableCell>
                                            <StyledTableCell component="th">
                                                {data?.leadWonDate
                                                    ? moment(data?.leadWonDate).format("DD-MM-YYYY")
                                                    : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell component="th">
                                                {data?.designerAssignedDate
                                                    ? moment(data?.designerAssignedDate).format("DD-MM-YYYY")
                                                    : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell component="th">
                                                {data?.designUser?.name ? data.designUser?.name : '-'}
                                            </StyledTableCell>
                                            <StyledTableCell component="th">
                                                {/* {data?.designManager?.name ? data.designManager?.name : '-'} */}
                                                {data?.designAssistantManager?.name ? data.designAssistantManager?.name : '-'}
                                            </StyledTableCell>
                                            {/* <StyledTableCell>
                                                {data?.projectedDesignSignOffDate?.before10th
                                                    ? moment(data.projectedDesignSignOffDate.before10th).format("DD-MM-YYYY")
                                                    : data?.projectedDesignSignOffDate?.committedDate
                                                        ? moment(data.projectedDesignSignOffDate.committedDate).format("DD-MM-YYYY")
                                                        : "-"}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {data?.projectedDesignSignOffDate.after10th
                                                    ? moment(data?.projectedDesignSignOffDate.after10th).format(
                                                        "DD-MM-YYYY"
                                                    )
                                                    : "-"}
                                            </StyledTableCell> */}
                                            <StyledTableCell component="th">
                                                {data?.currentStage}
                                            </StyledTableCell>
                                            <StyledTableCell component="th">
                                                {data?.designStatus}
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Modal>
        </div >
    );
}

export default connect(null, { setLoading, setSnackInfo })(OpsReview);